import React, { FC } from 'react'
import text from 'styles/utility/text.module.scss'

type Props = {
  title: string
}

const ContractCardTitle: FC<Props> = React.memo((props) => {
  const { title } = props
  return <h3 className={`${text.font_xxlarge} ${text.align_center} ${text.font_bold}`}>{title}</h3>
})

export default ContractCardTitle
